<template>
	<section class="small-12 residentsActivityTimeline">
        <div class="small-12 listingsTitle animated fadeIn">
            <h3 class="small-3 flex vertical-align">
                Latest Activity
            </h3>
        </div>
        <div class="small-12 chartOptions flex vertical-align justify-between" style="margin-bottom:20px;">
            <p class="auto">Total Events: <span>16</span></p>
            <p class="auto">{{ chartMonth }}</p>
        </div>
        <div class="small-12 columns chart chart-line-m" style="margin-top:10px;" v-if="chartData && chartOptions">
            <vertical-bar-chart :chartOptions="chartOptions" :chartData="chartData"></vertical-bar-chart>
        </div>
    </section>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

    // Import the components
	import VerticalBarChart from '@/components/framework/charts/VerticalBarChart.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ResidentsActivityTimeline',

		/*
		**  Register the components
		*/

		components: {

			VerticalBarChart

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			dateParam: 30,
			chartData: null,
			chartOptions: null,
			chartLabels: []

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	// Set the chart label dates
			this.setDates();

			// Populate the chart options
			this.populateChartOptions();

			// Set the empty chart - remove and add to watcher
			this.setEmptyChart();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			setDates: function() {

				try {

                    if (this.chartLabels.length == 0) {

                        // Set the var
                        let tempLabels = [],
                            daysInMonth = moment().daysInMonth(),
                            todaysMonth = moment().format('MM'),
                            todaysYear = moment().format('YYYY');

                        // Add dates to the temp array
                        for (let i = 1; i <= daysInMonth; i++) {

                            let optionDate = moment(todaysMonth + '/' + i + '/' + todaysYear).format('MMM D');

                            tempLabels.push(optionDate);

                        }

                        // Reverse the array and add to global object
                        this.chartLabels = tempLabels;

                    }

                } catch (e) {

                }

			},

            populateChartOptions: function() {

				// Populate the options
				this.chartOptions = {
					responsive: true, 
					maintainAspectRatio: false,
					scales: {
						 yAxes: [{
						 	display: true,
						 	beginAtZero: true,
                            ticks: {
                                display: false
                            },
						 	gridLines: {
			                    drawTicks: true,
			                    display: true,
			                    color: '#f4f6f8',
                                drawBorder: false
			                }
			            }],
			            xAxes: [{
			            	display: true,
			            	gridLines: {
			                    drawTicks: true,
			                    display: false,
			                    color: '#f4f6f8',
			                    zeroLineColor: '#f4f6f8'
			                }
			            }]
					},
					elements: {
	                    point:{
	                        radius: 0
	                    },
	                    line: {
				            tension: 0.4
				        }
	                },
	                legend: {
			            display: false
			        },
			        tooltips: {
				         enabled: true
				    },
				    layout: {
						padding: {
							top: 10
						}
					}
				}

			},

			setEmptyChart: function() {

				// Set the data based off of date param
				let tempData = [];

				for (let i = 0; i < this.dateParam; i++) {

					tempData.push(i);

				}

				// Populate the chart data
				this.chartData = {

					labels: this.chartLabels,
					datasets: [
						{
							label: 'Average',
							backgroundColor: '#18bbf7',
							borderColor: '#18bbf7',
							borderWidth: 1,
							data: tempData
						}
					]

				}

			}

		},

		/*
		**  Set the computed props
		*/

		computed: {

			chartMonth: function() {

                return moment().format('MMMM YYYY');

            }

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>